export default __webpack_public_path__ + "static/media/hr.e598c787.svg";